import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { QRCodeSVG } from 'qrcode.react'
import { Button } from '@/components/ui/button'
import { Logo } from '@/components/Logo'
import { StoreButtons } from '@/components/StoreButtons'
import { useIsMobile } from '@/hooks/useIsMobile'

export const Route = createFileRoute('/invite/accept/$token')({
  component: FamilyAccept,
})

function FamilyAccept() {
  const { token } = Route.useParams()
  const isMobile = useIsMobile()
  const appLink = `markur://invite/accept/${token}`
  const pageUrl = typeof window !== 'undefined' ? window.location.href : ''

  useEffect(() => {
    // Only auto-redirect on mobile devices
    if (!isMobile) return

    const timer = setTimeout(() => {
      window.location.href = appLink
    }, 100)
    return () => clearTimeout(timer)
  }, [appLink, isMobile])

  return (
    <div className="bg-muted flex min-h-screen items-center justify-center p-5">
      <div className="bg-background max-w-md rounded-2xl p-10 text-center shadow-lg">
        <div className="mb-10 flex justify-center">
          <Logo size="md" />
        </div>

        <h1 className="text-foreground mb-2 text-2xl font-bold">Family Invitation</h1>

        {isMobile ? (
          <>
            <p className="text-muted-foreground mb-8">You've been invited to join a family</p>
            <Button asChild size="lg" className="w-full">
              <a href={appLink}>Open in Markur App</a>
            </Button>
          </>
        ) : (
          <>
            <p className="text-muted-foreground mb-8">You've been invited to join a family</p>
            <div className="bg-background inline-block rounded-xl p-2">
              <QRCodeSVG
                value={pageUrl}
                size={180}
                level="M"
                marginSize={0}
                title="Scan to open family invitation on your phone"
              />
            </div>
            <p className="text-muted-foreground mb-12">Scan to open on your phone</p>
          </>
        )}

        <div className="mt-8">
          <p className="text-muted-foreground mb-4 text-sm">Don't have the app yet?</p>
          <StoreButtons size="sm" className="justify-center" />
        </div>
      </div>
    </div>
  )
}
